import { defineMessages } from "react-intl";

export default defineMessages({
  "serviceRequest.staleTaskModal.title.assigned": {
    id: "serviceRequest.staleTaskModal.title.assigned",
    defaultMessage: "This task has already been assigned to another provider",
  },
  "serviceRequest.staleTaskModal.title.full": {
    id: "serviceRequest.staleTaskModal.title.full",
    defaultMessage: "This task reached the maximum number of applications",
  },
  "serviceRequest.staleTaskModal.title.expired": {
    id: "serviceRequest.staleTaskModal.title.expired",
    defaultMessage: "This task has expired or has been cancelled",
  },
  "serviceRequest.staleTaskModal.subtext": {
    id: "serviceRequest.staleTaskModal.subtext",
    defaultMessage: "However, you can still look more recent jobs of the same category",
  },
  "serviceRequest.staleTaskModal.cta": {
    id: "serviceRequest.staleTaskModal.cta",
    defaultMessage: "See more recent jobs",
  },
});
